import {
  EXPERIENCIES_EXCLUSIVITIES_TO_REMOVE,
  RESET_EXCLUSIVITIES,
} from 'constants/exclusivity-experience';

export const experienciesExclusivitiesToRemoveAction = (data) => ({
  type: EXPERIENCIES_EXCLUSIVITIES_TO_REMOVE,
  payload: data,
});

export const resetExclusivitiesAction = () => ({
  type: RESET_EXCLUSIVITIES,
  payload: null,
});
